import { Button } from '@atom/button/button';
import { ButtonTypeEnum } from '@atom/button/button.enum';
import { PaginationCursorResponseInterface } from '@interface/logs/response-data.interface';
import { isString } from '@util/data/is-exist';

import { NextIcon, PaginationWrapper, PrevIcon } from './pagination.style';

interface PaginationProps {
  pagination: PaginationCursorResponseInterface;
  onNext?: () => void;
  onPrevious?: () => void;
}

export const PaginationCursor = ({ pagination, onNext, onPrevious }: PaginationProps) => {
  const hasPrevious = isString(pagination.previous);
  const hasNext = isString(pagination.next);

  if (!hasNext && !hasPrevious) return null;

  return (
    <PaginationWrapper>
      <Button disabled={!hasPrevious} type={ButtonTypeEnum.Link} onClick={onPrevious}>
        <PrevIcon isDisabled={!hasPrevious} />
      </Button>
      <Button disabled={!hasNext} type={ButtonTypeEnum.Link} onClick={onNext}>
        <NextIcon isDisabled={!hasNext} />
      </Button>
    </PaginationWrapper>
  );
};
